import { InformationCircleIcon } from "@heroicons/react/24/outline";

const CardButtons = ({
toggleInfo
}: {
  toggleInfo: () => void;
}) => {
  return (
    <div className="flex flex-row py-2 px-4 float-right">
      {/* <HeartIcon className="h-6 w-6 dark:text-white ml-2" /> */}
      <button onClick={toggleInfo}>
        <InformationCircleIcon className="h-6 w-6 dark:text-white ml-2" />
      </button>
    </div>
  );
};

export default CardButtons;
